import { loadable } from '../../common/utils/lazyLoading';
const ProgramGroups = loadable(() => import('./ProgramGroups'));
const ProgramHolidayCalendars = loadable(() => import('./ProgramHolidayCalendars'));
const ProgramCalendarTree = loadable(() => import('./ProgramCalendarTree'));
const TimetableTemplate = loadable(() => import('./TimetableTemplate'));
export default [
    {
        id: 'program_groups',
        title: 'Program Groups',
        route: 'program-groups',
        component: ProgramGroups,
        withEntityFormEditButton: true,
        icon: 'stack',
        permission: 'program_groups',
    },
    {
        id: 'program_holiday_calendars',
        title: 'Program Holiday Calendars',
        route: 'program-holiday-calendars',
        component: ProgramHolidayCalendars,
        withEntityFormEditButton: true,
        icon: 'stack',
        permission: 'program_holiday_calendars',
    },
    {
        id: 'program_calendar_cycles',
        title: 'Program Calendar Cycles',
        route: 'program-calendar-cycles',
        component: ProgramCalendarTree,
        withEntityFormEditButton: true,
        icon: 'stack',
        permission: 'program_calendar_tree',
    },
    {
        id: 'timetable_templates',
        title: 'Timetable Templates',
        route: 'timetable_templates',
        component: TimetableTemplate,
        withEntityFormEditButton: true,
        icon: 'stack',
        permission: 'timetable_templates',
    },
];
